import * as c3 from 'c3';
import Chart from 'src/javascripts/components/Chart';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import DistributionChartTooltip from 'src/javascripts/components/charts/tooltips/DistributionChartTooltip';

export default class DistributionChart extends Chart {

  getData() {

    // Set a spinner to indicate chart loading
    Spinner(this.el);

    // Set url
    let url = this.el.attr('data-api-url');
    let params = {};
    let queryId = this.el.attr('data-query-id');
    let metricId = this.el.attr('data-metric-id');
    let companyId = this.el.attr('data-company-id');
    if (typeof queryId !== 'undefined') {params['query_id'] = queryId}
    if (typeof metricId !== 'undefined') {params['metric_id'] = metricId}
    if (typeof companyId !== 'undefined') {params['company_id'] = companyId}

    // Set any additional params based on any filter attributes
    $.each(this.el.data(), function(key, val) {
      if (key.indexOf('filter') !== -1) {
        let k = key.replace("filters", "")
        k = k.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        k = k.slice(1);
        params[k] = val
      }
    })

    // Get data
    if (url.indexOf('?') !== -1) {
      return $.getJSON(url + '&' + $.param(params));
    } else {
      return $.getJSON(url + '?' + $.param(params));
    }

  }

  render(data) {

    // Set chartId
    const chartId = this.chartId;

    // Render chart
    const chart = c3.generate({
      bindto: '#' + chartId,
      padding: {left: 0, bottom: -30},
      data: {
        type: 'bar',
        json: data,
        labels: {
          format: function (v, id, i, j) {
           return v.toLocaleString("en"); 
         }
        },
        keys: {
          x: 'name',
          value: [ 'value' ]
        },
      },
      axis: {
        x: {type: 'category'},
        y: {
          show: false,
          padding: {top: 20}
        }
      },
      bar: {width: {ratio: 0.8}},
      legend: {hide: true},
      tooltip: {
        show: false
      },

      // Add color to bars
      onrendered() {
        if ((typeof data[0]["color_by_ratings"] !== 'undefined') && (data[0]["color_by_ratings"] === "true")) {
          $('.c3-bar-0').addClass('bg-a-rating');
          $('.c3-bar-1').addClass('bg-b-rating');
          $('.c3-bar-2').addClass('bg-c-rating');
          $('.c3-bar-3').addClass('bg-d-rating');
          $('.c3-bar-4').addClass('bg-f-rating');
        }
      }


    });

    // Set chart data to allow for destroying chart before Turbo cache
    // https://stackoverflow.com/questions/25765596/how-to-get-object-reference-from-selector-for-c3-js-charts
    $('#' + chartId).data('c3-chart', chart);

    return chart;

  }
};